import { render, staticRenderFns } from "./CadastreHistoricalViewModal.vue?vue&type=template&id=4b5f25cf&scoped=true&"
import script from "./CadastreHistoricalViewModal.vue?vue&type=script&lang=js&"
export * from "./CadastreHistoricalViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5f25cf",
  null
  
)

export default component.exports